var _ = require('lodash');
var numeral = require('numeral');
var React = require('react');
var Reflux = require('reflux');
var Slider = require('bootstrap-slider');

var analytics = require('analytics');
var storyScenarios = require('models/storyScenarios');

var ScrollSpyContentsMixin = require('views/scrollSpy/ScrollSpyContentsMixin');

var chartStore = require('stores/ChartStore');

var SCROLLSPY_PROPS = {
  id: 'scenario-down-round',
  name: 'Down Round'
};

var PERCENTAGE_FORMATTER = d3.format('%');

module.exports = React.createClass({displayName: "module.exports",
  mixins: [
    ScrollSpyContentsMixin,
    Reflux.listenTo(actions.chart.selectMeasure, '_onSelectMeasure'),
    Reflux.listenTo(actions.round.changeRoundPreMoneyValuation, '_onChangeRoundPreMoneyValuation')
  ],

  getInitialState:function() {
    return {
      scrollSpy: SCROLLSPY_PROPS,
      sliderValue: storyScenarios.rounds.seriesB.preMoneyValuation,
      sliderEnabled: false,
      wasFocused: false,
      lastMeasure: 'values'
    };
  },

  onScrollSpyFocus: function(target) {
    actions.ui.hideSelectRound(false);
    actions.ui.showPVScatter(true);
    actions.chart.selectMeasure('values');
    actions.round.setScenario(storyScenarios.rounds.seriesC);
    actions.round.changeRoundPreMoneyValuation(storyScenarios.rounds.seriesB, 6000000);
    actions.chart.selectRound(storyScenarios.rounds.seriesB);

    this.setState({
      sliderEnabled: true,
      wasFocused: true
    });

  },

  onScrollSpyUnfocus: function(target) {
    if (!this.state.wasFocused)
      return;

    actions.round.changeRoundPreMoneyValuation(storyScenarios.rounds.seriesB, this._origPreMoney);
    this.setState({
      sliderEnabled: false
    });
  },

  _onSelectMeasure: function(measure) {
    this.setState({
      lastMeasure: measure
    });
  },

  switchToPercentages:function() {
    analytics.event(
      analytics.E.ROUND_CHART_BUTTON.ID,
      analytics.E.ROUND_CHART_BUTTON.PERCENTAGE_VIEW,
      SCROLLSPY_PROPS.id
    );
    actions.chart.selectMeasure('percentages');
  },

  switchToValues:function() {
    analytics.event(
      analytics.E.ROUND_CHART_BUTTON.ID,
      analytics.E.ROUND_CHART_BUTTON.VALUE_VIEW,
      SCROLLSPY_PROPS.id
    );
    actions.chart.selectMeasure('values');
  },

  componentDidMount:function() {
    this._origPreMoney = storyScenarios.rounds.seriesB.preMoneyValuation;

    var slideStartMs;
    var slideStartValue;

    this._slider = new Slider( React.findDOMNode(this.refs.roundSlider), {
      enabled: this.state.sliderEnabled,
      value: this.state.sliderValue,
      min: 6000000,
      max: 60000000,
      step: 500000,
      formatter: function(n) {
        return numeral(n).format('$ 00.0a') + (
          n < 25000000 ? ' (Down Round)' : ''
        );
      },
      ticksPositions: [0, 50, 100],
      ticksLabels: ['Down Round', '|', 'Growth Round']
    })
    .on('change', this._onSliderChange)
    .on('slideStart', function(value) {
      slideStartMs = Date.now();
      slideStartValue = value;
    })
    .on('slideStop', function(slideEndValue) {
      analytics.event(
        analytics.E.SLIDER.ID,
        analytics.E.SLIDER.SLIDE_STOP,
        SCROLLSPY_PROPS.id,
        Date.now() - slideStartMs,
        {
          startValue: slideStartValue,
          endValue: slideEndValue
        }
      );
    });
  },

  _onSliderChange: function(sliderVals) {
    actions.round.changeRoundPreMoneyValuation(storyScenarios.rounds.seriesB, sliderVals.newValue, {throttle: true});

    actions.chart.selectRound(storyScenarios.rounds.seriesB);
  },

  _onChangeRoundPreMoneyValuation: function(round, value) {
    if (round !== storyScenarios.rounds.seriesB)
      return; // don't care about it

    this.setState({
      sliderValue: value,
      percentNewInvestor: 6000000 / (value + 6000000)
    });
  },

  render:function() {
    if (this._slider) {

      if (this.state.sliderEnabled) {
        this._slider.setValue( this.state.sliderValue, false, false );
        this._slider.enable();
      } else {
        this._slider.disable();
      }
    }

    return (
      React.createElement("div", {id: SCROLLSPY_PROPS.id}, 
        React.createElement("h1", {className: this.state.scrollSpy.isFocused ? 'focus' : ''}, "Down Round"), 
        React.createElement("p", null, 
          "A down round happens when your valuation decreases relative to the previous round.  Investors will still" + " " +
          "give you money, but on terms that value your company less than before.  Down rounds are dangerous because" + " " +
          "they can dilute your shares in a way that ", React.createElement("strong", null, "shift future value gains away from you (and existing" + " " +
          "investors) towards the new investors.")
        ), 
        React.createElement("p", null, 
          "A valuation is merely a number pulled out of thin air that all participants agree is appropriate. Viewed this" + " " +
          "way, ", React.createElement("strong", null, "your pre-money valuation is merely a knob your investors spin to determine what level" + " " +
          "of dilution results from a set investment amount"), ".  Lets see that in action."
        ), 

        React.createElement("div", {className: "panel panel-info"}, 
          React.createElement("div", {className: "panel-heading"}, 
            React.createElement("i", {className: "fa fa-hand-o-right"}, " "), " The Down Round"
          ), 
          React.createElement("div", {className: "panel-body"}, 

            React.createElement("p", null, 
              "Look at your Series B."
            ), 
            React.createElement("p", null, 
              "Your Series B investors are willing to give you a" + " " +
              "fixed ", React.createElement("span", {className: "highlight-round-money"}, React.createElement("strong", null, "$ 6M")), ".  How much you get diluted depends" + " " +
              "on the size of your ", React.createElement("span", {className: "highlight-round-options"}, "pre-"), React.createElement("span", {className: "highlight-round-valuation"}, "money valuation"), "." + " " +
              "Tweak it and note the relative composition of your Series B.  More" + " " +
              "importantly, ", React.createElement("strong", null, "note how differently the future Series C growth gets distributed after a down round.")
            ), 
            React.createElement("div", null, 
              React.createElement("div", {className: "pull-left", style: {height: '3em'}}, 
                React.createElement("span", {className: "highlight-round-options"}, "Ser"), React.createElement("span", {className: "highlight-round-valuation"}, "ies B Pre-Money Valuation"), ":    "
              ), 
              React.createElement("div", {style: {height: '3.5em'}}, 
                React.createElement("span", {ref: "roundSlider"}), " ", React.createElement("br", null), 
                React.createElement("small", null, "% Series C growth going to Series B investors: ", PERCENTAGE_FORMATTER(this.state.percentNewInvestor))
              )
            ), 
            React.createElement("p", null, " "), 

            React.createElement("div", {className: "btn-group poor-mans-toggle"}, 
              React.createElement("div", {
                className: 'btn ' + (this.state.lastMeasure === 'values' ? 'btn-default' : 'btn-primary disabled'), 
                onClick: this.switchToPercentages
              }, "Percentage View"), 
              React.createElement("div", {
                className: 'btn ' + (this.state.lastMeasure === 'values' ? 'btn-primary disabled' : 'btn-default'), 
                onClick: this.switchToValues
              }, "Value View")
            )
          )

        )


      )
    );
  }
});


/** WEBPACK FOOTER **
 ** /Users/dlopuch/developer/projects-venture-dealr/~/jsx-loader?harmony!./views/scrollSpyContents/DownRound.jsx
 **/